"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.UnlockSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M9 8v6h2V8a4 4 0 014-4h2a4 4 0 014 4 1 1 0 002 0 6 6 0 00-6-6h-2a6 6 0 00-6 6z"/><path d="M25 14H7a2 2 0 00-2 2v12a2 2 0 002 2h18a2 2 0 002-2V16a2 2 0 00-2-2zm-9 12a2 2 0 01-2-2 2 2 0 011-1.7V19a1 1 0 012 0v3.3a2 2 0 011 1.7 2 2 0 01-2 2z"/>';
var UnlockSVG = function UnlockSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.UnlockSVG = UnlockSVG;
UnlockSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(UnlockSVG);
exports.default = _default;